import Blog1 from "./blog1";
import Blog2 from "./blog2";
import Blog3 from "./blog3";

export const posts = [
  {
    id: 1,
    author: "Momore Oladeinde",
    title:
      "Unpacking Venture Economics: Insights into Startup Funding and Growth",
    description:
      "Explore venture economics: funding strategies, investor dynamics, scaling businesses, and insights for startup...",
    img: "https://firebasestorage.googleapis.com/v0/b/lasricv2.appspot.com/o/blog%2Fgenerative-ai-stock-market-chart-lines-financial-graph-technology-abstract-background_93150-2571.avif?alt=media&token=58acce71-539e-4ecf-90e3-90ac68a11df7",
    date: "15th December 2024",
    component: <Blog1 />,
  },

  {
    id: 2,
    author: "Momore Oladeinde",
    title:
      "Building a Winning Team: Strategies for Hiring Top Talent in Startups",
    description:
      "How to Attract, Hire, and Retain the Best Talent for Your Startup’s Success.",
    img: "https://firebasestorage.googleapis.com/v0/b/lasricv2.appspot.com/o/blog%2FM2A2H%402x.webp?alt=media&token=ebdd3a6c-e719-40c6-a942-84a9141dcd33",
    date: "15th December 2024",
    component: <Blog2 />,
  },

  {
    id: 3,
    author: "Ayodeji Yusuff",
    title:
      "The Role of LASRIC in Advancing Digital Transformation Across Sectors",
    description:
      "Driving Innovation and Technological Growth for a Smarter Future",
    img: "https://firebasestorage.googleapis.com/v0/b/lasricv2.appspot.com/o/blog%2F65d8574ccf980494e7d27cd0_Digital%20Transformation%20Easy.png?alt=media&token=0ac02e85-be50-4ed1-95fb-c53aecc0854e",
    date: "15th December 2024",
    component: <Blog3 />,
  },

  {
    id: 4,
    author: "Ayodeji Yusuff",
    title:
      "Leveraging Technology for Business Growth: Essential Tools for Startups in Lagos",
    description:
      "Maximizing Efficiency and Scaling Smart: The Must-Have Tech Tools for Lagos Startups",
    img: "https://firebasestorage.googleapis.com/v0/b/lasricv2.appspot.com/o/blog%2Fbusiness-stock-market-background-with-shiny-growth-arrow_1017-53572.avif?alt=media&token=dadfaeb0-8ebe-4d87-995c-52c7ea211a22",
    date: "15th December 2024",
  },

  {
    id: 5,
    author: "Ayodeji Yusuff",
    title:
      "A Step-by-Step Guide to Securing LASRIC Funding for Your Startup or Research Project",
    description:
      "How to Apply, Qualify, and Secure LASRIC Grants to Fund Your Innovation",
    img: "https://firebasestorage.googleapis.com/v0/b/lasricv2.appspot.com/o/blog%2FGgHt9v4WwAAA5LC.jpg?alt=media&token=7603aad2-361a-40d0-b61f-a908f6200d28",
    date: "15th December 2024",
  },
];
